import { render } from "./AdministrationContainersView.vue?vue&type=template&id=1b85655c&scoped=true"
import script from "./AdministrationContainersView.vue?vue&type=script&lang=js"
export * from "./AdministrationContainersView.vue?vue&type=script&lang=js"

import "./AdministrationContainersView.vue?vue&type=style&index=0&id=1b85655c&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b85655c"]])

export default __exports__